// The seven-metric grid (docs/phase-0/slice6-component-designs.md §4.1
// `PulseMetricGrid`; `.pulse-metric-grid`, an intrinsic `auto-fit`/`minmax` grid appended
// to `apps/web/src/styles/app.css`'s Slice-6 block). Always renders all seven
// `MetricName` values IN THEIR DECLARED ORDER (packages/shared/src/model/pulse.ts:13-21)
// - never reordered by width, never reordered by which ones have data (UX §4.5). The
// grid itself is deliberately UNLABELED (no `aria-labelledby` section wrapper): the
// seven cards are "a flat peer set, not a further-sectioned group" once the caller's own
// "Your seven metrics" `<h2>` precedes it (UX §4.6).
import { MetricName } from "@nightcrew/shared";
import type { AnomalySignal, AppStage, PulseMetricPoint } from "@nightcrew/shared";
import { PulseMetricCard } from "./PulseMetricCard.js";
import type { PulseTrendData } from "./PulseMetricTrend.js";

export const PulseMetricGrid = ({
  points,
  appStage,
  trendsByMetric,
  anomaliesByMetric,
}: {
  readonly points: readonly PulseMetricPoint[];
  readonly appStage: AppStage;
  readonly trendsByMetric?: Partial<Record<MetricName, PulseTrendData>>;
  readonly anomaliesByMetric?: Partial<Record<MetricName, AnomalySignal>>;
}): React.JSX.Element => (
  <div className="pulse-metric-grid">
    {MetricName.options.map((metric) => {
      const point = points.find((p) => p.metric === metric) ?? null;
      // exactOptionalPropertyTypes: only pass trend/anomaly when actually present (never undefined).
      const trend = trendsByMetric?.[metric];
      const anomaly = anomaliesByMetric?.[metric];
      return (
        <PulseMetricCard
          key={metric}
          metric={metric}
          point={point}
          appStage={appStage}
          {...(trend !== undefined ? { trend } : {})}
          {...(anomaly !== undefined ? { anomaly } : {})}
        />
      );
    })}
  </div>
);
